import { createSelector } from 'reselect';

import { YES_FLAG, adjustmentTypes, countryTaxTypes, US_COUNTRY_TAX_TYPE_REGEX } from '../../shared/constants';
import { accountsExcludedFromManualAdjustments } from '../constants';

export const adjustmentTypeOptionsSelector = createSelector(
  ({ adjustmentTypes }) => adjustmentTypes,
  ({ countryTaxType }) => countryTaxType,
  ({ countryTaxTypeDescriptions }) => countryTaxTypeDescriptions,
  ({ statCalc }) => statCalc,
  (adjustmentTypesList, countryTaxType, statCalc) => {
    let validTypes = [];
    if (countryTaxType === countryTaxTypes.US2) {
      validTypes = [
        adjustmentTypes.PERM,
        adjustmentTypes.TEMP,
        adjustmentTypes.TAX_CREDIT,
        adjustmentTypes.STATE_ADJUSTMENT,
        adjustmentTypes.PRE_TAX_ADJUSTMENT,
        adjustmentTypes.PRIOR_CREDIT_UTILIZATION,
      ];
    } else if (US_COUNTRY_TAX_TYPE_REGEX.test(countryTaxType)) {
      validTypes = [
        adjustmentTypes.TAX_CREDIT,
        adjustmentTypes.STATE_PERM_MODS,
        adjustmentTypes.STATE_TEMP_MODS,
        adjustmentTypes.PRIOR_CREDIT_UTILIZATION,
      ];
    } else {
      validTypes = [
        adjustmentTypes.TEMP,
        adjustmentTypes.PERM,
        adjustmentTypes.TAX_CREDIT,
        adjustmentTypes.PRE_TAX_ADJUSTMENT,
        adjustmentTypes.PRIOR_CREDIT_UTILIZATION,
      ];

      if (statCalc) {
        validTypes = [
          ...validTypes,
          adjustmentTypes.GAAP_TO_STAT_REVERSING,
          adjustmentTypes.GAAP_TO_STAT_NON_REVERSING,
        ];
      }
    }
    return adjustmentTypesList.filter(({ value }) => validTypes.includes(value));
  }
);

export const accountOptionsSelector = createSelector(
  ({ account }) => account,
  ({ accounts, amountFrom }) => amountFrom === YES_FLAG
    ? accounts.filter(({ allowAdjustmentFlag }) => allowAdjustmentFlag === YES_FLAG)
    : accounts.filter(account => !accountsExcludedFromManualAdjustments.includes(account.value)),
  ({ adjustmentToEdit }) => adjustmentToEdit,
  (account, accounts, adjustmentToEdit) => {
    if (!accounts.length || !adjustmentToEdit) {
      return accounts;
    }

    const accountToAdd = {
      value: account,
      label: account,
    };

    return [accountToAdd, ...accounts];
  }
);
